// 接口 - 用户事件
import { get, post } from '@/api/base/request';
import { apiPrefix } from '@/api/url';

const {baseApi} = apiPrefix;

// 用户事件 - 列表
export function getEventList(params){
  return post(`${baseApi}/market_sys/event/get`, params);
}
// 用户事件 - 下拉选项
export function getEventPageOptions(params){
  return get(`${baseApi}/market_sys/event/getSelectList`, params);
}
// 用户事件 - 新增、修改
export function eventAddOrUpdate(params){
  return post(baseApi + "/market_sys/event/add", params);
}


// 营销归属 - 列表
export function getOspList(params){
  return post(`${baseApi}/market_sys/source/get`, params);
}
// 营销归属 - 下拉选项
export function getOspPageOptions(params){
  return get(`${baseApi}/market_sys/source/getSelectList`, params);
}
// 营销归属 - 新增、修改
export function ospAddOrUpdate(params){
  if (params.id > 0) return post(baseApi + "/market_sys/source/update", params);
  return post(baseApi + "/market_sys/source/add", params);
}


// 消息内容 - 列表
export function getMsgList(params){
  return post(`${baseApi}/market_sys/msg/get`, params);
}
// 消息内容 - 下拉选项
export function getMsgPageOptions(params){
  return get(`${baseApi}/market_sys/msg/getSelectList`, params);
}
// 消息内容 - 文件上传
export const msgUploadFile = (params={}, options={}) => {
  const data = new FormData();
  Object.keys(params).forEach((item) => {
    data.append(item, params[item]);
  });

  return post(`${baseApi}/market_sys/msg/uploadFile`, data, {
    headers: {"Contennt-Type": "multipart/form-data",},
    noValid: true,
    ...options,
  });
}



// 转化归因 - 转化 - 列表
export function getStatsConversionList(params){
  return get(`${baseApi}/market_sys/transform/marketTransform`, params);
}
// 转化归因 - 记录 - 列表
export function getStatsRecordList(params){
  return get(`${baseApi}/market_sys/transform/marketRecord`, params);
}